let _config = null

export async function loadRemoteConfig() {
	if (_config) return _config
	const res = await fetch(`${process.env.PUBLIC_URL}/config.json`)
	_config = await res.json()
	if (!_config?.features?.enableLanguageToggle) {
		localStorage.setItem('sdoc_lang', 'th')
	}
	return _config
}

export function getFeatureFlag(key) {
	return _config?.features?.[key] ?? false
}
